import { DeviceModel } from './device';
import { RoleModel } from './role';

export class UserAccountModel {
    
    _id: string;
    user_code: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    mothers_maiden_name: string;
    user_email: string;
    username: string;
    password: string;
    require_password_change: boolean;
    show_terms: boolean;
    accepted_terms: boolean;
    timestamp_accepted_terms: Date;
    status: string;
    access_code: string;
    devices: DeviceModel[];
    roles: RoleModel;

    full_name: string;
    full_sur_name: string;
    is_selected: boolean;

    constructor(user_code?: string) {
        this.roles = new RoleModel();
        this.user_code = user_code;
    }

}
